import { render } from "./TrailerStandAloneApp.vue?vue&type=template&id=0fa3cb52"
import script from "./TrailerStandAloneApp.vue?vue&type=script&lang=js"
export * from "./TrailerStandAloneApp.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__